import * as React from "react";
import { Component } from "react";

import * as styles from "./ValidationLabel.less";

export enum validationThemes {
    common_error = "common_error",
    error = "error",
    input_with_label = "input_with_label",
    custom_fields_error = "custom_fields_error",
    error_at_bottom = "error_at_bottom",
}

interface Props {
    text: string;
    theme?: string;
    id?: string;
}

export class ValidationLabel extends Component<Props> {
    getClassName(theme: string) {
        switch (theme) {
            case validationThemes.common_error:
                return styles.common_error;
            case validationThemes.error:
                return styles.error;
            case validationThemes.custom_fields_error:
                return styles.custom_fields_error;
            case validationThemes.error_at_bottom:
                return styles.error_at_bottom;
            case validationThemes.input_with_label:
                return styles.input_with_label;
        }
    }

    render() {
        const theme = this.props.theme || validationThemes.error;
        const themeClasses = this.getClassName(theme);

        return (
            <div className={themeClasses} id={this.props.id}>
                {this.props.text}
            </div>
        );
    }
}
